import {
    VariantInputType,
    VARIANT_INPUT_TYPE,
} from '../containers/ticketSelection/constants';

export const isMultipleVariantType = ({
    variantInputType,
}: {
    variantInputType?: VariantInputType;
}) => variantInputType === VARIANT_INPUT_TYPE.MULTIPLE;
